export default __webpack_public_path__ + "static/drawing-4335b0fa48bf6e211ea3f14a7c143962.png";